(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SedutaDetailController', SedutaDetailController);

    SedutaDetailController.$inject = ['$scope', '$rootScope', '$state', '$timeout', 'toastr', 'previousState', 'entity', 'Seduta', 'SedutaCommonService', 'workingBody', 
        'organismiSeduta', 'docTypes', 'Commissione', 'SoggettoEsterno', 'OrdineDelGiorno', 'FileSaver', 'legislature', '$mdDialog', '$mdSidenav', 'editable', 'utente'];

    function SedutaDetailController($scope, $rootScope, $state, $timeout, toastr, previousState, entity, Seduta, SedutaCommonService, workingBody, 
        organismiSeduta, docTypes, Commissione, SoggettoEsterno, OrdineDelGiorno, FileSaver, legislature, $mdDialog, $mdSidenav, editable, utente) {
        var vm = this;

        vm.seduta = entity;
        vm.utente = utente;
        vm.previousState = previousState.name;
        vm.previousStateParams = previousState.params;
        vm.workingBody = workingBody;
        vm.legislature = legislature;
        vm.legislatureOrganismo = legislature;
        vm.showStateHistory;
        vm.isEditing = editable;
        vm.isNumberEditing = false;
        vm.dateformat = "dd/MM/yyyy HH:mm";
        vm.ordiniDelGiorno = [];
        vm.docsToUpdate = [];

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dataDiConvocazioneEdit = false;
        vm.openCalendar = openCalendar;
        vm.prepareEditing = prepareEditing;
        vm.prepareNumberEditing = prepareNumberEditing;
        vm.saveSeduta = saveSeduta;
        vm.changeDocumentVisibility = changeDocumentVisibility;
        vm.changeDocumentType = changeDocumentType;
        vm.updateDocuments = updateDocuments;
        vm.performButtonAction = performButtonAction;
        vm.generateAffariTrattatiDocument = generateAffariTrattatiDocument;
        vm.generateAffariTrattatiPDFReport = generateAffariTrattatiPDFReport;
        vm.toggleEsitoPublish = toggleEsitoPublish;
        vm.legislaturaChanged = legislaturaChanged;
        vm.organismoWorkingBody = {};
        vm.canSeeEditButton = canSeeEditButton;
        vm.canSeeEditNumberButton = canSeeEditNumber;
        
        initController();

        var unsubscribe = $rootScope.$on('gestioneAttiApp:sedutaUpdate', function(event, result) {
            vm.seduta = result;
        });
        $scope.$on('$destroy', unsubscribe);

        var confirmTransitionDlg = $mdDialog.confirm()
                .title('Attenzione!')
                .textContent("L'operazione richiesta non è reversibile, sei sicuro di voler procedere?")
                .ariaLabel('conferma transizione di stato')
                .ok('Conferma')
                .cancel('Annulla');

        function initController(){

            vm.organismiSeduta = organismiSeduta;
            // Prima recupera l'organizzatore dagli organismi
            vm.organismoWorkingBody = SedutaCommonService.getOrganismoWorkingBodyFromOrganismiSeduta(vm.organismiSeduta, vm.workingBody);
            // Se non trovato, evita errori e prosegui con valori di fallback
            if(!vm.organismoWorkingBody) {
                console.log('Organismo working body non trovato. Procedo con fallback.');
                vm.organismoWorkingBody = {};
            }
            // Poi rimuove l'organizzatora dalla lista (per non presentarlo nella selezione dei partecipanti)
            if(SedutaCommonService.isOrganizzatore(vm.seduta, vm.workingBody)) {
                SedutaCommonService.removeWorkingBodyFromOrganismiSeduta(vm.organismiSeduta, vm.workingBody);
            }

            if (vm.organismoWorkingBody.nome) {
                vm.workingBody.nome = vm.organismoWorkingBody.nome;
            }
            vm.legislatureOrganismo = vm.organismoWorkingBody.legislature || vm.legislature;
            vm.seduta.partecipantiSeduta = SedutaCommonService.getPartecipantiSeduta(vm.seduta);
            SedutaCommonService.fromSedutaBEToSedutaView(vm.seduta, vm.workingBody, vm.organismiSeduta);

            //Recupero ordini del giorno seduta
            OrdineDelGiorno.getAllByIdSeduta({idSeduta: vm.seduta.id},
                function (data) {
                    vm.ordiniDelGiorno = data;
                },
                onError);

            function onError(error) {
                toastr.error(error.data.message);
            }

            initButtons();

            vm.docTypes = docTypes;
            vm.docsToUpdate = [];
            
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function prepareEditing(){
            vm.isEditing = !vm.isEditing;
            initButtons();
        }

        function prepareNumberEditing(){
            vm.isNumberEditing = !vm.isNumberEditing;
        }

        function saveSeduta(){
            if(SedutaCommonService.fromSedutaViewToSedutaBE(vm.seduta, vm.workingBody)){
                if (vm.seduta.id !== null) {
                    Seduta.update({typeOrg: vm.workingBody.tipoOrganismo, idOrg: vm.workingBody.id }, vm.seduta, onSaveSuccess, onSaveError);
                } else {
                    Seduta.saveWithWB({typeOrg: vm.workingBody.tipoOrganismo, idOrg: vm.workingBody.id }, vm.seduta, onSaveSuccess, onSaveError);
                }

                vm.updateDocuments();
            }
            
        }

        function onSaveSuccess(result) {
            toastr.success("Seduta salvata con successo");
            vm.isEditing = false;
            vm.isNumberEditing = false;
            reloadPage();
        }

        function onSaveError(error) {
            toastr.error("Errore nel salvataggio della seduta.");
            vm.isEditing = false;
            vm.isNumberEditing = false;
        }

        function canSeeEditNumber(seduta){
            if (SedutaCommonService.canEditSedutaNumber(vm.utente, seduta, vm.workingBody)) {
                return SedutaCommonService.isSedutaEditable(seduta) && !vm.isEditing;
            } else {
                return false;
            }
        }

        function canSeeEditButton(seduta) {
            if (SedutaCommonService.canEditSeduta(vm.utente, seduta, vm.workingBody)) {
                return SedutaCommonService.isSedutaEditable(seduta) && !vm.isEditing;
            }
            return false;
        }

        function initButtons(){
            vm.visibleButtons = [];

            if(SedutaCommonService.canEditSeduta(vm.utente, vm.seduta, vm.workingBody)) {

                if(vm.seduta.statoCorrente.statoSeduta === 'A' && vm.isEditing) {
                    vm.visibleButtons.push(
                        {
                            title: "entity.action.publishAffariTrattati",
                            action: publishAffariTrattati,
                            iconClass: "glyphicon-send",
                            nextStateName : "PAT"
                        },
                        {
                            title: "entity.action.publishSeduta",
                            action: publishSeduta,
                            iconClass: "glyphicon-send",
                            nextStateName : "P"
                        },
                        {
                            title: "entity.action.revocationSeduta",
                            action: revokeSeduta,
                            iconClass: "glyphicon-thumbs-down",
                            nextStateName : "X"
                        }
                    );
                } else if(vm.seduta.statoCorrente.statoSeduta === 'PAT' && vm.isEditing) {
                    vm.visibleButtons.push(
                        {
                            title: "entity.action.publishSeduta",
                            action: publishSeduta,
                            iconClass: "glyphicon-send",
                            nextStateName : "P"
                        },
                        {
                            title: "entity.action.revocationSeduta",
                            action: revokeSeduta,
                            iconClass: "glyphicon-thumbs-down",
                            nextStateName : "X"
                        }
                    );
                } else if(vm.seduta.statoCorrente.statoSeduta === 'P') {
                    vm.visibleButtons.push(
                        {
                            title: "entity.action.revocationSeduta",
                            action: revokeSeduta,
                            iconClass: "glyphicon-thumbs-down",
                            nextStateName : "X"
                        }
                    );
                }
            }

        }

        function publishAffariTrattati(newState){
            $mdDialog.show(confirmTransitionDlg).then(function () {
                transitionTo('PAT');
            });
        }

        function publishSeduta(newState){
            $mdDialog.show(confirmTransitionDlg).then(function () {
                transitionTo('P');
            });
        }

        function revokeSeduta(newState){
            $mdDialog.show(confirmTransitionDlg).then(function () {
                transitionTo('X');
            });
        }

        function transitionTo(newState) {
            Seduta.sedutaStateTransition({id: vm.seduta.id, nextStateName: newState} , null , function (success) {
                if(newState === 'P' || newState === 'PAT') {
                    toastr.success('Seduta <b>aggiornata</b> con successo', 'Okay!');
                } else if( newState === 'X') {
                    toastr.success('Seduta <b>revocata</b> con successo', 'Okay!');
                }
                reloadPage();
            }, function (error) {
                var labelStato;
                if(newState === 'PAT') labelStato = "Pubblicazione Affari Trattati";
                if(newState === 'P') labelStato = "Pubblicata";
                if(newState === 'X') labelStato = "Revocata";
                toastr.error('Impossibile eseguire il passaggo allo stato <b>' + labelStato + '</b>:<br/>' + error.data.description, 'Errore!');
            });
        }

        function performButtonAction(button){
            if(button.action){
                button.action( button.nextStateName);
            }
        }

        function reloadPage() {
            $timeout(function () {
                $state.reload();
            }, 0);
        }

        function generateAffariTrattatiDocument(){         
            vm.documentParams = {
                legislatura: vm.seduta.legislatura,
                numeroSeduta: vm.seduta.numeroSeduta,
                idSeduta: vm.seduta.id
            };

            Seduta.generateAffariTrattatiDocument({}, vm.documentParams, onSuccess, onError);

            function onSuccess(result) {
                toastr.success('Documento ODG scaricato con successo nella cartella Download!');
            }
            function onError(error) {
                console.log(error);
            }
        }

        function generateAffariTrattatiPDFReport() {
            Seduta.getAffariTrattatiPDFReport(vm.seduta.id).then(
                function(result) {
                    FileSaver.saveAs(new Blob([result.data], {}), "reportAffariTrattati.pdf");
                }, 
                function(error) {
                    var errorCode = error.headers('X-gestioneAttiApp-error');
                    var errorText = '';
                    if(errorCode === 'error.noContent') {
                        errorText = 'Nessun affare trattato e\' stato trovato per questa seduta';
                    } else if(errorCode === 'error.forbiddenOp') {
                        errorText = 'La tua utenza non e\' abilitata alla generazione di report. Si prega di contattare l\'amministratore'
                    } else {
                        errorText = 'Errore inaspettato. Si prega di riprovare o contattare l\'amministratore!'
                    }
                    toastr.error(errorText, "Errore!", {
                        timeOut: 60000,
                        extendedTimeOut: 0
                    });
                });
        }
        function toggleEsitoPublish () {
            $mdSidenav('sedutaEsitoPublish').toggle();
        }

        function legislaturaChanged() {
            Seduta.organismiSeduta({legislature: vm.seduta.legislatura}, function(result) {
                vm.organismiSeduta = result;
                // Prima recupera l'organizzatore dagli organismi
                vm.organismoWorkingBody = SedutaCommonService.getOrganismoWorkingBodyFromOrganismiSeduta(vm.organismiSeduta, vm.workingBody);
                if(!vm.organismoWorkingBody) {
                    console.log('Organismo working body non trovato dopo cambio legislatura. Fallback.');
                    vm.organismoWorkingBody = {};
                }
                if (vm.organismoWorkingBody.nome) {
                    vm.workingBody.nome = vm.organismoWorkingBody.nome;
                }
                vm.legislatureOrganismo = vm.organismoWorkingBody.legislature || vm.legislature;
                // Poi rimuove l'organizzatora dalla lista (per non presentarlo nella selezione dei partecipanti)
                if(SedutaCommonService.isOrganizzatore(vm.seduta, vm.workingBody)) {
                    SedutaCommonService.removeWorkingBodyFromOrganismiSeduta(vm.organismiSeduta, vm.workingBody);
                }
            });
        }

        function changeDocumentVisibility(doc, newDocumentVisibility) {
            markDocumentForUpdate(doc);
        }

        function changeDocumentType(doc, newDocumentType) {
            markDocumentForUpdate(doc);
        }

        function markDocumentForUpdate(doc) {
            var foundIndex = -1;
        
            for (var i = 0; i < vm.docsToUpdate.length; i++) {
                if (vm.docsToUpdate[i].id === doc.id) {
                    foundIndex = i;
                    break;
                }
            }
        
            if (foundIndex === -1) {
                vm.docsToUpdate.push(doc);
            } else {
                vm.docsToUpdate[foundIndex] = doc;
            }
        }


        function updateDocuments() {
            
            if(vm.docsToUpdate) {
                angular.forEach(vm.docsToUpdate, function(doc) {
                    Seduta.updateDocument({id: vm.seduta.id, idDoc: doc.id }, doc, onSuccessDoc, onErrorDoc);
                });
            }
        }

        function onSuccessDoc(result) {
            toastr.success('Documento aggiornato!');
        }
        function onErrorDoc(error) {
            toastr.error('Impossibile salvare alcuni documenti: ' + ((error && error.data) ? error.data.message : 'Errore Sconosciuto'), 'Errore!');
        }

    }
})();
